/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `SAFI` - Safi
* `CUSTOMER` - Customer
* `FIXED_DATE` - Fixed date
 */
export type WhoFixesDateEnum = typeof WhoFixesDateEnum[keyof typeof WhoFixesDateEnum];


export const WhoFixesDateEnum = {
  SAFI: 'SAFI',
  CUSTOMER: 'CUSTOMER',
  FIXED_DATE: 'FIXED_DATE',
} as const;
